module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre11",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('table', {
    staticClass: "calibre12",
    attrs: {
      "border": "0",
      "cellpadding": "5",
      "cellspacing": "0",
      "summary": "Contents"
    }
  }, [_c('colgroup', {
    staticClass: "calibre13"
  }, [_c('col', {
    staticClass: "calibre14"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre14"
  })]), _vm._v(" "), _c('tbody', {
    staticClass: "calibre16"
  }, [_c('tr', {
    staticClass: "calibre17"
  }, [_c('th', {
    staticClass: "smfontr"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('th', {
    staticClass: "tdl"
  }), _vm._v(" "), _c('th', {
    staticClass: "smfontr"
  }, [_vm._v("PAGE")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#I"
    }
  }, [_vm._v("Kit Carson to the Rescue")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("17")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0008#II"
    }
  }, [_vm._v("Under the Wagon")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("30")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0009#III"
    }
  }, [_vm._v("Oliver Wins His Spurs")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("43")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Word from Old Fort Laramie")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("56")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frémont Says “Onward!”")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("68")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Wilder West")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("87")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Over the Famed South Pass")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("96")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planting the Highest Flag")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("111")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Voyaging of the Platte")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("124")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frémont Calls Again")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("135")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Hostile Territory")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("147")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emigrant Trail")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("155")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To the Great Salty Lake")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("167")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sailing the Inland Sea")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("178")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On to the Columbia")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("192")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022#XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southward for the Unknown")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("203")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023#XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scant Christmas Comfort")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("216")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024#XVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forcing the Snowy Sierras")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("225")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XIX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025#XIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the Last Gasp")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("235")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0026#XX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down Through California")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("248")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XXI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0027#XXI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vengeance of Kit Carson")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("259")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XXII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0028#XXII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poor Tabeau Pays the Price")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("276")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdrt"
  }, [_vm._v("XXIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0029#XXIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Home Stretch")])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("288")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0